<template>
  <div class="logo-container flex flex-row items-center gap-2">
    <img
      src="/images/spicy-collab-icon.png"
      class="h-10 w-10 shrink-0 object-contain"
      alt="Spicy Collab"
    />
    <span class="whitespace-nowrap text-xl font-bold text-black">Spicy Collab</span>
  </div>
</template>

<script setup></script>

<style scoped>
  .logo-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70% !important;
  }
</style>
